import React, { memo } from 'react';

import { areEqual } from 'Utils/equalityChecks';
import { UserProfileWrapper } from 'Components/Profiles';

import { BulkExportContainer } from 'Containers/GHL/BulkExport';

const DataExportContainer = () => (
  <UserProfileWrapper tab="data-export">
    <BulkExportContainer />
  </UserProfileWrapper>
);

const DataExportContainerMemo = memo(DataExportContainer, areEqual);

export { DataExportContainerMemo as DataExport };
